export default "__VITE_ASSET__Zb22aSsn__"